import { useState } from "react";
import { Button } from "@hub/ui/components/ui/button";
import { Input } from "@hub/ui/components/ui/input";
import { Label } from "@hub/ui/components/ui/label";

interface EmailStepProps {
  onSubmit: (email: string) => void;
  onApiKeySubmit?: (apiKey: string) => void;
  loading: boolean;
  error: string | null;
}

export function EmailStep({ onSubmit, onApiKeySubmit, loading, error }: EmailStepProps) {
  const [email, setEmail] = useState("");
  const [apiKey, setApiKey] = useState("");
  const [useApiKey, setUseApiKey] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (useApiKey) {
      if (apiKey.trim() && onApiKeySubmit) {
        onApiKeySubmit(apiKey.trim());
      }
    } else {
      if (email.trim()) {
        onSubmit(email.trim());
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      {error && (
        <div className="rounded-md bg-red-50 dark:bg-red-900/20 p-3 border border-red-200 dark:border-red-800/50">
          <p className="text-sm text-red-600 dark:text-red-400">{error}</p>
        </div>
      )}

      {useApiKey ? (
        <div className="space-y-2">
          <Label htmlFor="apiKey">API Key</Label>
          <Input
            id="apiKey"
            type="password"
            placeholder="hub_xxxxx..."
            value={apiKey}
            onChange={(e) => setApiKey(e.target.value)}
            autoFocus
            required
          />
        </div>
      ) : (
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoFocus
            required
          />
        </div>
      )}

      <Button type="submit" variant="primary" className="w-full" loading={loading}>
        {useApiKey ? "Sign In" : "Continue"}
      </Button>

      {onApiKeySubmit && (
        <div className="text-center">
          <Button
            type="button"
            variant="link"
            onClick={() => setUseApiKey(!useApiKey)}
            className="text-sm text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
          >
            {useApiKey ? "Sign in with email instead" : "Sign in with API key"}
          </Button>
        </div>
      )}
    </form>
  );
}
